import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import playStore from '../assets/images/playstore.png';
import appStore from '../assets/images/appstore.png';
import footerImage from '../assets/images/footer-image.png';
import logoGodenSecond from '../assets/images/logo-golden-second.png';

const Footer: React.FC = () => {

  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const isOnboardingRoute = location.pathname.includes('onboarding');

  const HandleMenu = (menu: string) => {
    if (isOnboardingRoute) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }
    else if (menu === 'home' || menu === 'aboutus') {
      navigate('/');
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('scrollToSection', {
          detail: { section: menu }
        }));
      }, 100);
    } else {
      navigate(menu);
    }
  }


  return (
    <main className="bg-primary flex flex-col">
      {/* footer top */}
      <div className="flex flex-col md:flex-row lg:flex-row gap-2 md:gap-4 lg:gap-10 my-6 mx-10 md:mx-6 lg:my-8 lg:mx-20">
        {/* footer logo */}
        <div className="flex md:w-1/3 lg:my-4 items-center justify-center">

          <img src={logoGodenSecond} alt='logo=golden=second' className='md:h-32 lg:h-44' />

        </div>
        <div className=" md:hidden mt-6 w-full h-px bg-goldenDark"></div>
        {/* footer links */}
        <div className="flex md:flex-row lg:gap-8 md:gap-5 lg:w-3/12">
          <div className="w-px h-full bg-goldenDark"></div>
          <div className="pt-5">
            <ul className="space-y-2 text-secondary  font-outfit font-normal text-sm md:text-base">
              <li><button onClick={() => HandleMenu('home')} className="hover:text-golden transition-colors duration-300">
                Home
              </button></li>
              <li><button onClick={() => HandleMenu('aboutus')} className="hover:text-golden transition-colors duration-300">
                About Us
              </button></li>
              <li><button onClick={() => HandleMenu('/contact-us')} className="hover:text-golden transition-colors duration-300">
                Contact Us
              </button></li>
              <li><button onClick={() => HandleMenu('/privacy-policy')} className="hover:text-golden transition-colors duration-300">
                Privacy Policy
              </button></li>
              <li><button onClick={() => HandleMenu('/refund-policy')} className="hover:text-golden transition-colors duration-300">
                Refund Policy
              </button></li>
              <li><button onClick={() => HandleMenu('/terms-conditions')} className="hover:text-golden transition-colors duration-300">
                Terms & Conditions
              </button></li>
            </ul>
          </div>
        </div>
        <div className=" md:hidden mt-6  w-full h-px bg-goldenDark"></div>
        {/* footer follow us */}
        <div className="flex md:flex-row lg:gap-8 md:gap-5 md:pl-12 font-outfit">
          <div className="w-px h-full bg-goldenDark" />
          <div className='flex flex-col gap-3 my-3'>
            <h1 className='text-secondary text-lg font-normal'>Download Our App</h1>
            <span className='flex flex-row md:flex-col lg:flex-row'>
              <a href='#'>
                <img src={appStore} alt='appstoreImage' className='w-32' />
              </a>
              <a href='#'>
                <img src={playStore} alt='playstoreImage' className='w-32' />
              </a>
            </span>
            <h1 className='text-secondary text-lg font-normal mt-2'>Follow Us</h1>
            <span className='flex gap-3'>
              <a href='#'>
                <Instagram className='size-6 text-secondary hover:text-golden' />
              </a>
              <a href='#'>
                <Facebook className='size-6 text-secondary hover:text-golden' />
              </a>
            </span>
          </div>
        </div>
      </div>
      {/* footer bottom */}
      <div className='flex flex-col gap-0 items-center'>
        <img src={footerImage} alt='footerImage' className='w-48 md:w-auto' />
        <div className="flex flex-col text-center text-goldenDark font-outfit font-normal text-xs md:text-sm mb-3 md:mb-5">
         <span> &copy; {currentYear} All Rights Reserved. </span>
         <span>Designed & Developed by <a className="underline" href="https://www.origanetworks.com/" target="_blank" rel="noreferrer">Origa Networks</a></span>
        </div>
      </div>
    </main>
  );
};

export default Footer;